const radii = {
  button: '2px',
};

export default radii;
